import React from 'react';
import ContainerXL from 'Nori/Container/ContainerXL';
import Button from 'Nori/Button';
import RichText from 'Custom/RichText';
import styles from 'Custom/ActionStrip/index.module.scss';
import ButtonStyles from 'Nori/Button/index.module.scss';

const BUTTON_VARIANT = {
  secondary2Light: 'primaryLight',
  secondary4Light: 'primaryLight',
  default: 'primaryLight',
};

const BUTTON_SIZES = {
  small: ButtonStyles.small,
};

const ActionStrip = ({
  title = '',
  className = '',
  color = '#2A4875',
  size = 'small',
  designModuleNo = '00',
  buttonLabel = '',
  buttonHref = '/',
  children,
  ...props
}) => {
  
  const buttonVariant = BUTTON_VARIANT[color] || BUTTON_VARIANT.default;
  const sizeClassName = BUTTON_SIZES[size] || BUTTON_SIZES.default;
  return (
    <div
      className={`${styles.actionStrip} ${className}`}
      data-qa-tag="action-strip"
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="Inline Content"
      data-design-module_name={title}
      data-design-module_no={designModuleNo}
      {...props}
    >
      <ContainerXL className={styles.actionStripContainer} data-qa-tag="action-strip-container">
        <RichText
          className={styles.richTextWrapper}
          data-qa-tag="richText-action-strip"
        >
        <div className={styles.actionStripContent} data-qa-tag="action-strip-content">
          <span className={styles.actionStripTitle} data-qa-tag="action-strip-title">
            {title}
          </span>
        </div>
        {buttonLabel && (
          <Button
            className={`${sizeClassName} ${styles.whiteButton}`}
            type={buttonVariant}
            size="small"
            href={buttonHref}
            target="_blank"
            rel="noopener"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label={buttonLabel}
            data-design-nori_id="Inline Content"
            data-design-module_name={title}
            data-design-module_no={designModuleNo}
            // className={styles.actionStripButton}
            data-qa-tag="action-strip-button"
          >
            {buttonLabel}
          </Button>
        )}
        </RichText>
      </ContainerXL>
    </div>
  );
};

export default ActionStrip;
